import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

import { ButtonComponent, InputTextComponent, IsEnglishDirective } from "src/app/shared";

@Component({
  selector: "app-rejection-message-dialoge",
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule, RouterLink, IsEnglishDirective, InputTextComponent, ButtonComponent],
  templateUrl: "./rejection-message-dialoge.component.html",
  styleUrl: "./rejection-message-dialoge.component.scss",
})
export class RejectionMessageDialogeComponent {
  data = inject(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<RejectionMessageDialogeComponent>);

  isEnglish = true;
  rejectionForm!: FormGroup;

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.initForm();
  }

  initForm() {
    this.rejectionForm = this.fb.group({
      exception: [null, [Validators.required]],
    });
  }

  onDismiss(): void {
    this.dialogRef.close(this.rejectionForm.value);
  }
}
